import React, { useEffect, Component } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { App } from './App';
import { PromptHomePage } from './pages/PromptHomePage';
import { PromptHomePageChat } from './pages/PromptHomePageChat';
import { CaseStudyUSBank } from './pages/CaseStudyUSBank';
import { CaseStudyCyberSecurity } from './pages/CaseStudyCyberSecurity';
import { CaseStudyAIComparison } from './pages/CaseStudyAIComparison';
import { CaseStudyCaseWestern } from './pages/CaseStudyCaseWestern';
import { CaseStudyAmira } from './pages/CaseStudyAmira';
import { PortfolioProvider, usePortfolio } from './context/PortfolioContext';
// Component to handle chat query parameter
function ChatQueryHandler({
  children
}: {
  children: React.ReactNode;
}) {
  const location = useLocation();
  const {
    openChatDrawer
  } = usePortfolio();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('chat') === 'open') {
      // Small delay to ensure page is loaded
      setTimeout(() => {
        openChatDrawer();
        // Track drawer open from query param
        if (typeof window !== 'undefined' && (window as any).gtag) {
          ;
          (window as any).gtag('event', 'chat_opened', {
            event_category: 'Chat',
            event_label: 'Query Parameter',
            source: 'url_param'
          });
        }
      }, 100);
    }
  }, [location.search, openChatDrawer]);
  return <>{children}</>;
}
// Redirect component for old AI mode
function AIPortfolioRedirect() {
  const navigate = useNavigate();
  useEffect(() => {
    // Redirect to traditional portfolio with chat open
    navigate('/portfolio/traditional?chat=open', {
      replace: true
    });
    // Track redirect
    if (typeof window !== 'undefined' && (window as any).gtag) {
      ;
      (window as any).gtag('event', 'ai_mode_redirect', {
        event_category: 'Navigation',
        event_label: 'AI Mode to Chat Drawer',
        from: '/portfolio/ai'
      });
    }
  }, [navigate]);
  return null;
}
export function AppRouter() {
  return <HelmetProvider data-id="element-20">
      <Router data-id="element-21">
        <PortfolioProvider data-id="element-22">
          <Routes data-id="element-23">
            {/* Main portfolio - direct entry */}
            <Route path="/" element={<ChatQueryHandler data-id="element-25">
                  <App data-id="element-26" />
                </ChatQueryHandler>} data-id="element-24" />
            <Route path="/portfolio" element={<ChatQueryHandler data-id="element-28">
                  <App data-id="element-29" />
                </ChatQueryHandler>} data-id="element-27" />
            <Route path="/portfolio/traditional" element={<ChatQueryHandler data-id="element-31">
                  <App data-id="element-32" />
                </ChatQueryHandler>} data-id="element-30" />

            {/* AI Portfolio view - REDIRECT to traditional with chat open */}
            <Route path="/portfolio/ai" element={<AIPortfolioRedirect data-id="element-34" />} data-id="element-33" />

            {/* Legacy AI Portfolio (original search-based) - keep for reference */}
            <Route path="/portfolio/ai-legacy" element={<PromptHomePage data-id="element-36" />} data-id="element-35" />

            {/* Case study routes */}
            <Route path="/case-study/amira" element={<CaseStudyAmira data-id="element-38" />} data-id="element-37" />
            <Route path="/case-study/us-bank" element={<CaseStudyUSBank data-id="element-40" />} data-id="element-39" />
            <Route path="/case-study/cyber-security" element={<CaseStudyCyberSecurity data-id="element-42" />} data-id="element-41" />
            <Route path="/case-study/ai-comparison" element={<CaseStudyAIComparison data-id="element-44" />} data-id="element-43" />
            <Route path="/case-study/case-western" element={<CaseStudyCaseWestern data-id="element-46" />} data-id="element-45" />

            {/* Legacy routes - redirect to main portfolio */}
            <Route path="/original" element={<Navigate to="/" replace data-id="element-48" />} data-id="element-47" />
            <Route path="/login" element={<Navigate to="/" replace data-id="element-50" />} data-id="element-49" />
            <Route path="/role-selection" element={<Navigate to="/" replace data-id="element-52" />} data-id="element-51" />
            <Route path="/portfolio/hiring-manager" element={<Navigate to="/" replace data-id="element-54" />} data-id="element-53" />
            <Route path="/portfolio/recruiter" element={<Navigate to="/" replace data-id="element-56" />} data-id="element-55" />
            <Route path="/portfolio/hiring-manager-choice" element={<Navigate to="/" replace data-id="element-58" />} data-id="element-57" />
            <Route path="/portfolio/recruiter-choice" element={<Navigate to="/" replace data-id="element-60" />} data-id="element-59" />
            <Route path="/portfolio/general" element={<Navigate to="/" replace data-id="element-62" />} data-id="element-61" />

            {/* Catch all - redirect to main portfolio */}
            <Route path="*" element={<Navigate to="/" replace data-id="element-64" />} data-id="element-63" />
          </Routes>
        </PortfolioProvider>
      </Router>
    </HelmetProvider>;
}